import PropTypes from 'prop-types'

import MagnifyingGlassButton from 'src/assets/img/shop/magnifying_glass.png'
import { useShopContext } from 'src/pages/main/shop/contexts/ShopContext'
import ChickenIcon from 'src/assets/img/chicken-icon.png'

import HelperModal from 'src/pages/main/shop/components/ShopExchangeTab/HelperModal'

const Helper = ({ point, itemName, currentPoint }) => {
  const { closeModal, setModalContent, setButtons, setTitle } = useShopContext()

  const handleSelect = () => {
    setButtons([
      {
        label: 'OK',
        onClick: closeModal
      }
    ])
    setTitle('交換ポイント')
    setModalContent(<HelperModal />)
  }

  return (
    <div className="relative flex items-start">
      <div className="text-left max-w-[180px]">
        <div className="text-xs text-[#FF4747] font-bold">
          <p>交換ポイント {point}到達で</p>
          <p className="flex max-w-[210px]">
            <span className="min-w-0 overflow-hidden whitespace-nowrap text-ellipsis">
              {itemName}
            </span>
            <span className="flex-shrink-0">1枚と交換コケ♪</span>
          </p>
        </div>
        <p className="pl-1 text-candy-pink">
          現在の到達 <span className="text-[#FF4747]">{currentPoint || 0}</span> pt
        </p>
      </div>
      <div className="w-[74px] h-14 overflow-clip">
        <img
          className="-mt-2 -ml-3 w-[119px] h-[119px] object-cover object-left -rotate-6"
          src={ChickenIcon}
          alt="icon chicken"
        />
      </div>
      <button className="absolute top-[42px] right-16 z-10" onClick={handleSelect}>
        <img src={MagnifyingGlassButton} className="w-5" />
      </button>
    </div>
  )
}

Helper.propTypes = {
  point: PropTypes.number.isRequired,
  itemName: PropTypes.string.isRequired,
  currentPoint: PropTypes.number
}

export default Helper
